import React, { useEffect, useRef, useContext, useState } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { slugify } from "../../../utils";
import { FontSizeContext } from "../../../context/fontSizeContext";
import { BiBorderRadius } from "react-icons/bi";

const BlogGrid = ({ data, classOption = "thumb" }) => {
    const { fontSize } = useContext(FontSizeContext);
    const textRefs = useRef([]);
    const [defaultSizes, setDefaultSizes] = useState([]);

    const adjustFontSize = (change) => {
        textRefs.current.forEach((element, index) => {
            if (element) {
                const computedStyle = window.getComputedStyle(element);
                const currentSize = parseFloat(computedStyle.fontSize);
                const newSize = currentSize + change;
                element.style.fontSize = `${newSize}px`;
            }
        });
    };

    const resetFontSize = () => {
        textRefs.current.forEach((element, index) => {
            if (element && defaultSizes[index] !== null) {
                element.style.fontSize = `${defaultSizes[index]}px`;
            }
        });
    };

    useEffect(() => {
        if (fontSize == 0) {
            resetFontSize();
        } else {
            adjustFontSize(fontSize);
        }
    }, [fontSize]);

    useEffect(() => {
        const sizes = textRefs.current.map((element) => {
            if (element) {
                const computedStyle = window.getComputedStyle(element);
                return parseFloat(computedStyle.fontSize);
            }
            return null;
        });
        setDefaultSizes(sizes);
    }, []);

    return (
        <div className="blog-card">
            <div className={`thumb text-center ${classOption}`}>
                <img
                    style={{ borderRadius: "0.5rem" }}
                    src={`${process.env.PUBLIC_URL}${data.icon}`}
                    alt=""
                    className="logo mb-3"
                    width={"25%"}
                />
            </div>
            <div
                className="blog-content text-center"
                style={{ backgroundColor: "#cdeda0", height: "155px" }}
            >
                <h3
                    style={{
                        fontSize: "14px",
                    }}
                    className="b-color"
                >
                    <b>{data.excerpt}</b>
                </h3>
                <p
                    className="b-color"
                    style={{
                        fontSize: "13px",
                    }}
                >
                    {data.details}
                </p>
                {/* <h3 ref={(el) => (textRefs.current[2] = el)}>
                    <b>{data.excerpt}</b>
                </h3> */}
            </div>
        </div>
    );
};

BlogGrid.propTypes = {
    data: PropTypes.object,
    classOption: PropTypes.string,
};

export default BlogGrid;
